import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/map/page.tsx");
